import { apiDocflow } from './api';

export const getDropboxAuthLink = () => {
    return apiDocflow.get('dropbox/auth');
}